import axiosPublicClient from "../../../../../../axiosPublicClient"

const service = async ({ requestKey, file, fileName, fileExtension }) => {

    const response = await axiosPublicClient.post('/pre-check-additional-document-media-url', {
        key: requestKey,
        fileName,
        fileExtension,
    })

    if (!response?.data?.url || !response?.data?.key) {
        throw new Error('Upload URL or key missing from response')
    }

    const { url, key: assetKey } = response.data

    await axiosPublicClient.put(url, file, {
        headers: {
            'Content-Type': file.type,
        },
    })

    // Best-effort: kick off the malware scan now so the candidate's own "view what I uploaded" works
    // as soon as it clears. The authoritative scan trigger is the form-progress save on the backend,
    // so a failure here is ignored — it only affects how soon the preview becomes available.
    try {
        await axiosPublicClient.post('/pre-check-additional-document-scan', {
            key: requestKey,
            documentKey: assetKey,
        })
    }
    catch (e) {
        // ignore — the backend save will trigger the scan regardless
    }

    return { key: assetKey }
}

export default service
